module.exports = __webpack_public_path__ + "./docs/img/big-icon-typedef.9fae7dde78725303d8be4b91c185f490.svg";